import React, { FC } from 'react'

const Union: FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H3V7.05001C4.14112 7.28164 5 8.29052 5 9.5C5 10.7095 4.14112 11.7184 3 11.95V16H2V11.95C0.85888 11.7184 0 10.7095 0 9.5C0 8.29052 0.85888 7.28164 2 7.05001V0ZM2 8.08535C1.4174 8.29127 1 8.84689 1 9.5C1 10.1531 1.4174 10.7087 2 10.9146C2.15639 10.9699 2.32468 11 2.5 11C2.67532 11 2.84361 10.9699 3 10.9146C3.5826 10.7087 4 10.1531 4 9.5C4 8.84689 3.5826 8.29127 3 8.08535C2.84361 8.03008 2.67532 8 2.5 8C2.32468 8 2.15639 8.03008 2 8.08535ZM7 0H8V2.05001C9.14112 2.28164 10 3.29052 10 4.5C10 5.70948 9.14112 6.71836 8 6.94999V16H7V6.94999C5.85888 6.71836 5 5.70948 5 4.5C5 3.29052 5.85888 2.28164 7 2.05001V0ZM7 3.08535C6.4174 3.29127 6 3.84689 6 4.5C6 5.15311 6.4174 5.70873 7 5.91465C7.15639 5.96992 7.32468 6 7.5 6C7.67532 6 7.84361 5.96992 8 5.91465C8.5826 5.70873 9 5.15311 9 4.5C9 3.84689 8.5826 3.29127 8 3.08535C7.84361 3.03008 7.67532 3 7.5 3C7.32468 3 7.15639 3.03008 7 3.08535ZM13 0H12V9.05001C10.8589 9.28164 10 10.2905 10 11.5C10 12.7095 10.8589 13.7184 12 13.95V16H13V13.95C14.1411 13.7184 15 12.7095 15 11.5C15 10.2905 14.1411 9.28164 13 9.05001V0ZM13 10.0854C12.8436 10.0301 12.6753 10 12.5 10C12.3247 10 12.1564 10.0301 12 10.0854C11.4174 10.2913 11 10.8469 11 11.5C11 12.1531 11.4174 12.7087 12 12.9146C12.1564 12.9699 12.3247 13 12.5 13C12.6753 13 12.8436 12.9699 13 12.9146C13.5826 12.7087 14 12.1531 14 11.5C14 10.8469 13.5826 10.2913 13 10.0854Z"
      />
    </svg>
  )
}

export default Union
